<template>
  <v-card>
    <v-row>
      <v-col cols="12" md="8" lg="6" offset-md="2" offset-lg="3">
        <div class="box">
          <v-layout
            d-block
            d-md-flex
            row
            ma-0
            align-center
            justify-space-between
            class="box-header"
          >
            <template v-if="contentBox && contentBox.length > 0">
              <template v-for="(item, index) in contentBox">
                <h3 v-if="item.type === 'title' && item.text" :key="index" v-html="item.text"></h3>
              </template>
            </template>
          </v-layout>

          <div class="box-content">
            <v-alert
              v-model="alert"
              :type="alertType"
            >
              {{ alertMessage }}
            </v-alert>

            <template v-if="contentBox && contentBox.length > 0">
              <template v-for="(item, index) in contentBox">
                <p v-if="item.type === 'text' && item.text" :key="index">
                  <pre v-html="item.text"></pre>
                </p>
              </template>
            </template>

            <div class="text-center">
              <v-btn
                rounded
                elevation="0"
                color="primary"
                class="fetch mt-3"
                to="/"
              >
                {{ $t('signup-confirm.cta') }}
              </v-btn>

              <!-- <template v-if="alertType == 'error'">
                <span class="px-3"></span>
                <v-btn
                  outlined
                  rounded
                  color="primary"
                  class="fetch mt-3"
                  @click="resend"
                >
                  {{ $t('signup-confirm.cta-2') }}
                </v-btn>
              </template> -->
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { signUpMeConfirm } from '@/js/auth/signup/signupConfirm'
import { getStatic } from '@/js/static/getStatic'

export default {
  data () {
    return {
      login: this.$route.params.login ? this.$route.params.login : '',
      key: this.$route.params.key ? this.$route.params.key : '',

      alert: false,
      alertType: 'error',
      alertMessage: this.$t('basic-message.error-message'),

      contentBox: null
    }
  },
  // methods: {
  //   resend () {
  //     if (this.$route.params.login && this.$route.params.key) {
  //       const uri = `?options=email&login=${encodeURIComponent(this.$route.params.login)}&key=${encodeURIComponent(this.$route.params.key)}`

  //       signUpMeConfirm(uri)
  //         .then(response => {
  //           console.log(response)
  //         })

  //     } else {
  //       this.alert = false
  //       this.alertType = 'error'
  //       this.alertMessage = this.$t('basic-message.error-message')
  //     }
  //   }
  // },

  created () {
    const params = {
      lang: (this.$i18n.locale == 'en-EN') || (this.$i18n.locale == 'en') ? 'en' :
            (this.$i18n.locale == 'fr-FR') || (this.$i18n.locale == 'fr') ? 'fr' :
            (this.$i18n.locale == 'nl-NL') || (this.$i18n.locale == 'nl') ? 'nl' : 'fr',
      page: 'signupconfirm',
      keyword: 'box1'
    }
    getStatic(params)
      .then(response => { this.contentBox = response.modules })

    if (this.$route.params.login && this.$route.params.key) {

      const uri = `?options=json&login=${encodeURIComponent(this.$route.params.login)}&key=${encodeURIComponent(this.$route.params.key)}`

      signUpMeConfirm(uri)
        .then(response => {
          if (response.status && response.status == 'ok') {
            this.alert = true
            this.alertType = response.alertType
            this.alertMessage = response.alertMessage

          } else {
            this.alert = true
            this.alertType = 'error'
            this.alertMessage = this.$t('basic-message.error-message') 
          }
        })
        .catch(() => {
          this.alert = true
          this.alertType = 'error'
          this.alertMessage = this.$t('basic-message.error-message')
        })

    } else {
      this.alert = false
      this.alertType = 'error'
      this.alertMessage = this.$t('basic-message.error-message')
    }
  }
}
</script>
